export const SET_ACCORDIONS = 'SET_ACCORDIONS';
export const UPDATE_ACCORDIONS = 'UPDATE_ACCORDIONS';
